export const ScreenReaderBasic = `
// Usage as a mixin
.skip-navigation {
  @include sr-only;
  @include sr-only-focusable;
}`
